//菜单
export const menu = {
  enterprise: "Enterprise",
  vn: "Virtual Network",
  product: "Product",
  mobility: "Mobility",
  technology: "Technology",
  download: "Download",
  aboutUs: "About Us",
  awards: "Awards",
  news: "News",
};
//企业
export const enterprise = {
  t: "Enterprise IT services are gradually migrating to hybrid cloud",
  c: "There are relatively mature solutions for business virtualization, but the network connection only completes the local area network virtualization, and the WAN connection remains in the traditional mode. WAN connection virtualization requires data control, which is oriented toward unified management, scheduling, and configuration, and data forwarding is oriented toward resource concentration and sharing.",
  t1: "Wide area network deployment based on SD WAN architecture to assist enterprise hybrid networking",
  c1: "Through multi-type SD-WAN CPE, connect to the cloud POP point via the Internet, realize fast, convenient, high-quality, low-cost hybrid networking. Support the smooth evolution of traditional WAN networking to SD-WAN, protect existing investments and business consistency, and help enterprise data centers to gradually migrate to the cloud.",
  t2: "SD-WAN Cloud Express Solution-Smart WAN",
  c2: "Enterprise cross-border networking between domestic and foreign branches/branch offices/customer headquarters/data centers, corresponding to dedicated lines or MPLS, to achieve high-speed and low-latency hybrid cloud interconnection with domestic 3-layer connections. It is recommended that each channel of high-definition conferences use 4M and above bandwidth , After the company’s internal networking, all data is transmitted on the internal network, AES256 encryption can ensure data security, support hybrid networking, make full use of existing investments, support low-cost expansion, SD-WAN centralized control system, configuration and security strategies can be combined Unified push to all access points.",
  kt: "Lower The Cost",
  kt1: "High Quality",
  kt2: "Express Delivery",
  kt3: "Easy To Manage",
  kt4: "High Availability",
  kt5: "Flexibility",
  kc: "Compared with the existing MPLS/dedicated line solution, the cost and TCO are reduced by 80%",
  kc1: "The overall network is based on SD-WAN technology, which can effectively ensure line stability",
  kc2: "Open business within one week, zero configuration of branches",
  kc3: "Unified management and configuration of global branches and unified monitoring of network conditions",
  kc4: "All branches adopt the master-backup solution",
  kc5: "Compared with MPLS/dedicated line, it has stronger virtualization capabilities and supports richer and faster networking solutions",
};

//多点组网
export const vn = {
  t: "Virtual Network solution",
  c: "Office points only need to be connected to the public network to form a network. Branch areas are directly connected to SD-WAN backbone access points through dedicated lines or broadband. The Northwest region uses FastIP technology to optimize public network transmission and then connects to Central China access points or cloud relays. Point, the province uses FastIP technology to optimize public network transmission and then directly connects to the headquarters, supporting equipment and link-level active-standby or dual-active mode.",
  cc: "No need to change the existing system architecture, no need to invest in any fixed assets in advance, save construction and maintenance costs, optimize transmission quality through algorithms without increasing costs, fast deployment cycle, unified visual management of the entire network, support for hybrid networking, and fully Use existing resources and AES-256 strong encryption to ensure the security of customer data.",
  t1: "Branch storefront network architecture",
  c1: "Support multiple access modes, LTE, broadband and MPLS. Supports different user volumes based on different types of equipment used by various branches. Branch stores use S/D series equipment. The headquarters uses R equipment.",
};

//移动应用
export const mob = {
  t: "Multi-platform client application to improve the efficiency of mobile office and remote office",
  c: "We have multi-platform client programs such as windows, mac, android, ios, etc., which can use the universal client of all services of Europe-Shenzhen, and can support all mainstream mobile and desktop devices, and can enjoy safe and convenient network access through any device",
  f: "After using the service, you can do cross-border high-speed access between different countries",
  f1: "Support multiple desktop and mobile systems",
  f2: "One-click login high-speed and secure encrypted link",
  f3: "Support seamless docking of corporate accounts",
  go: "go to download",
};

//设备
export const dv = {
  //rx
  rxs: "Standard 1U",
  rxu: "Users",
  rxesim: "Built-in esim",
  rxno: "N/A",
  rxv100: "According to cloud configuration",
  rxv100a: "Cloud Virtual image",
  rxv100u: "Public Cloud/Private Cloud",
  rxv100t: "Virtual device",
  rxv100t1: "Virtual Edge Connector",
  rxv100t2: "Applicable public cloud private cloud platform",
  dtt: "High-performance small and medium-sized equipment",
};

export default { menu, enterprise, vn, mob, dv };



// WEBPACK FOOTER //
// ./src/i18n/en.js